var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3066 9.46823V22.8C19.3066 22.9381 19.1946 23.05 19.0566 23.05H1.99996C1.86189 23.05 1.74996 22.9381 1.74996 22.8V9.46823C1.74996 9.39275 1.78407 9.3213 1.84277 9.27384L10.3711 2.37765C10.4628 2.30351 10.5938 2.30351 10.6855 2.37765L19.2138 9.27384C19.2725 9.3213 19.3066 9.39275 19.3066 9.46823Z",
    fill: "#36495A",
    stroke: "#36495A",
    strokeWidth: 3.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 12.75,
    width: 7.5,
    height: 9.5,
    rx: 2.25,
    fill: "white",
    stroke: "#36495A",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 3,
    width: 3,
    height: 5,
    rx: 1,
    fill: "#36495A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome8);
export default __webpack_public_path__ + "static/media/home8.c62435f4d5ebd300abf6ea7b65cd6a94.svg";
export { ForwardRef as ReactComponent };